<template>
  <v-dialog v-model="isOpen"
    persistent
    scrollable
    content-class="user-pref-dialog">
    <v-card>
      <v-toolbar class="escalon-dialog-header secondary" height="35">
        <img
          class="modal-axis-logo mr-2"
          :src="require('../../assets/' + coloredLogo)" />
        <span>{{modalTitle}}</span>
        <v-spacer />
        <v-btn text @click="$emit('close')">
          <v-avatar size="20" class="mr-2">
            <img :src="require('../../assets/' + coloredAssetUrls.close)" />
          </v-avatar>Close
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 90%;">
        <h2 class="user-pref-modal-header secondary">Default Color Scheme</h2>
        <v-container fluid grid-list-md>
          <v-layout>
            <v-flex 
              md3 
              v-if="prefs.defaultColorTheme === 'green'"
              class="theme-container">
              <v-btn
                class="themes-btn theme-selected"
                :class="colorClass"
                v-on:click="this.selectedDarkGreenTheme"
                bottom
                text>
                  <img class="themes-icon" src="../../assets/theme1.png" />
              </v-btn>
              <span class="themes-text">Dark Background - Green</span>
            </v-flex>

            <v-flex 
              md3 
              v-else
              class="theme-container">
              <v-btn 
                class="themes-btn"
                :class="colorClass"
                v-on:click="this.selectedDarkGreenTheme"
                bottom
                text>
                <img class="themes-icon" src="../../assets/theme1.png" />
              </v-btn>
              <span class="themes-text">Dark Background - Green</span>
            </v-flex>

            <v-flex 
              md3 
              v-if="prefs.defaultColorTheme === 'dark-blue'"
              class="theme-container">
              <v-btn
                class="themes-btn theme-selected"
                :class="colorClass"
                v-on:click="this.selectedDarkBlueTheme"
                bottom
                text>
                <img class="themes-icon" src="../../assets/theme2.png" />
              </v-btn>
              <span class="themes-text">Dark Background - Blue</span>
            </v-flex>
            <v-flex 
              md3 
              v-else 
              v-on:click="this.selectedDarkBlueTheme"
              class="theme-container">
              <v-btn 
                class="themes-btn" 
                :class="colorClass"
                bottom 
                text>
                  <img class="themes-icon" src="../../assets/theme2.png" />
              </v-btn>
              <span class="themes-text">Dark Background - Blue</span>
            </v-flex>

            <v-flex 
              md3 
              v-if="prefs.defaultColorTheme === 'gray'"
              class="theme-container">
              <v-btn
                class="themes-btn theme-selected"
                :class="colorClass"
                v-on:click="this.selectedDarkGrayTheme"
                bottom
                text>
                <img class="themes-icon" src="../../assets/theme2.png" />
              </v-btn>
              <span class="themes-text">Dark Background - Gray</span>
            </v-flex>

            <v-flex 
              md3 
              v-else
              class="theme-container">
              <v-btn class="themes-btn"
                :class="colorClass"
                v-on:click="this.selectedDarkGrayTheme"
                bottom
                text>
                <img class="themes-icon" src="../../assets/theme2.png" />
              </v-btn>
              <span class="themes-text">Dark Background - Gray</span>
            </v-flex>

            <v-flex md3 
              v-if="prefs.defaultColorTheme === 'white'"
              class="theme-container">
              <v-btn
                class="themes-btn theme-selected"
                :class="colorClass"
                v-on:click="this.selectedLightTheme"
                bottom
                text>
                <img class="themes-icon" src="../../assets/theme3.png" />
              </v-btn>
              <span class="themes-text">Light Background - Green</span>
            </v-flex>

            <v-flex
              md3 
              v-else
              class="theme-container">
              <v-btn class="themes-btn"
                :class="colorClass"
                v-on:click="this.selectedLightTheme"
                bottom
                text>
                <img class="themes-icon" src="../../assets/theme3.png" />
              </v-btn>
              <span class="themes-text">Light Background - Green</span>
            </v-flex>
          </v-layout>
        </v-container>
        <h2 class="user-pref-modal-header secondary" v-if="openPrefs">Default Settings</h2>
        <v-container fluid grid-list-md v-if="openPrefs">
          <v-layout class="flex-wrap">
            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">List Page Size</label>
              </div>
              <select-with-button
                class="select-btn"
                v-model="prefs.pageSize"
                :items="pageSize"
                name="props.prefs.pageSize"
                data-vv-as="pageSize"/>
            </v-flex>

            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">Full Screen View</label>
              </div>
              <select-with-button
                class="select-btn"
                v-model="prefs.fullscreens"
                :items="fullScreen"
                name="prefs.fullscreens"
                data-vv-as="fullscreens"/>
            </v-flex>

            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">Auto Patient Refresh</label>
              </div>
              <select-with-button
                class="select-btn"
                v-model="prefs.autoPatientExamRefresh"
                :items="autoPatientExamRefresh"
                name="prefs.autoPatientExamRefresh"
                data-vv-as="autoPatientExamRefresh"/>
            </v-flex>

            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">Patient Date Setting</label>
              </div>
              <select-with-button
                class="select-btn"
                v-model="prefs.patientDateSetting"
                :items="patientDateSetting"
                name="prefs.patientDateSetting"
                data-vv-as="patientDateSetting"/>
            </v-flex>

            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">HVF Order</label>
              </div>
              <select-with-button
                class="select-btn"
                v-model="prefs.defaultHVF"
                :items="defaultHVF"
                name="prefs.defaultHVF"
                data-vv-as="defaultHVF"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">Default HVF View</label>
              </div>
              <select-with-button
                class="select-btn"
                v-model="prefs.defaultHVFview"
                :items="defaultHVFViewOptions"
                name="prefs.defaultHVFview"
                data-vv-as="defaultHVFview"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">Default Cirrus View</label>
              </div>
              <select-with-button
                class="select-btn"
                v-model="prefs.defaultCirrusView"
                :items="defaultCirrusView"
                name="prefs.defaultCirrusView"
                data-vv-as="defaultCirrusView"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">Cirrus Scan Display Ratio</label>
              </div>
              <select-with-button
                class="select-btn"
                v-model="prefs.cirrusScanDisplayRatio"
                :items="cirrusScanRatioOptions"
                name="prefs.cirrusScanDisplayRatio"
                data-vv-as="cirrusScanDisplayRatio"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">Multiview Collapse By Default</label>
              </div>
              <select-with-button
                class="select-btn"
                v-model="prefs.multiviewCollapse"
                :items="multiviewCollapseOptions"
                name="prefs.multiviewCollapse"
                data-vv-as="multiviewCollapse"/>
            </v-flex>
          </v-layout>
        </v-container>
        <h2 class="user-pref-modal-header secondary" v-if="openPrefs">Password Reset</h2>
        <div class="errorMsg" v-if="errorMsg != null">{{errorMsg}}</div>
        <v-container fluid grid-list-md>
          <v-layout wrap v-if="isPass === true">
            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">Old Password</label>
              </div>
              <v-text-field
                class="pass-text"
                type="password"
                v-model="oldPassword"
                name="oldPassword"
                data-vv-as="oldPassword"
                v-validate="{ required: isPass }"
                solo/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">New Password</label>
              </div>
              <v-text-field
                class="pass-text"
                type="password"
                v-model="newPassword"
                name="newPassword"
                data-vv-as="newPassword"
                v-validate="{ required: isPass, regex: this.regex }"
                solo/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass">Confirm Password</label>
              </div>
              <v-text-field
                class="pass-text"
                type="password"
                v-model="confirmNewPass"
                name="confirmNewPass"
                data-vv-as="confirmNewPass"
                v-validate="{ required: isPass, regex: this.regex }"
                solo/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label" :class="colorClass"></label>
              </div>
              <v-btn text
                @click="submitPass"
                class="button-Password">Change Password</v-btn>
              <v-btn text
                @click="closePass"
                class="button-Password">Cancel</v-btn>
            </v-flex>
          </v-layout>
          <v-layout wrap v-else>
              <v-btn slot="activator" text icon>
                <v-avatar size="30">
                  <img :src="require('../../assets/' + coloredAssetUrls.refresh)" />
                </v-avatar>
              </v-btn>
              <v-btn
                text
                @click="changePass"
                class="modal-cta">Change Password</v-btn>
          </v-layout>
          <span v-if="isPass === true">Passwords must be at least 8 characters in length and contain 1 uppercase letter, 1 lowercase letter, 1 number, and 1 of the following symbols !@#$%^&*</span>
        </v-container>
        <v-container v-if="openPrefs" class="submit-cancel"></v-container>
      </v-card-text>
      <v-card-actions
        class="secondary">
        <v-btn 
          text
          @click="closeWithoutSave" 
          class="modal-cta primary" 
          :class="colorClass">Cancel</v-btn>
        <v-btn 
          text 
          @click="submit" 
          class="modal-cta primary"
          :class="colorClass">Save Changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {
  PAGE_SIZE,
  GENDERS,
  FULL_SCREEN,
  PATIENT_DATE_SETTING_USERPREF,
  AUTO_REFRESH,
  DEFAULT_HVF_ORDER,
  DEFAULT_CIRRUS_VIEW,
  SINGLE_OR_MULTI_USERPREF,
  COLOR_TYPE,
  MULTIVIEW_COLLAPSE_BY_DEFAULT,
  DEFAULT_MACULAR_CUBE_SCAN_RATIO_USER_PREF
} from "../../config/config.js";
import selectWithButton from "../../components/controls/SelectWithButton";
import { mapGetters } from "vuex";

export default {
  name: "userPrefs",
  components: {
    selectWithButton
  },
  props: {
    openPrefs: Boolean,
    patientDateSettings: Boolean,
    examLocations: String,
    fullScreens: Boolean,
    patient: Object,
    files: Array,
    upload: Object,
    isEditing: Boolean,
    isAdding: Boolean,
    exam: Object,
    propPrefs: Object
  },
  data() {
    return {
      dobMenu: false,
      pageSize: PAGE_SIZE,
      genders: GENDERS,
      patientDateSetting: PATIENT_DATE_SETTING_USERPREF,
      defaultHVF: DEFAULT_HVF_ORDER,
      defaultCirrusView: DEFAULT_CIRRUS_VIEW,
      fullScreen: FULL_SCREEN,
      autoPatientExamRefresh: AUTO_REFRESH,
      defaultHVFViewOptions: SINGLE_OR_MULTI_USERPREF,
      multiviewCollapseOptions: MULTIVIEW_COLLAPSE_BY_DEFAULT,
      colorSchemeOptions: COLOR_TYPE,
      cirrusScanRatioOptions: DEFAULT_MACULAR_CUBE_SCAN_RATIO_USER_PREF,
      physicians: [],
      examTypes: [],
      errorMsg: null,
      isPass: false,
      oldPassword: null,
      newPassword: null,
      confirmNewPass: null,
      prefs: this.propPrefs,
      regex: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/)
    };
  },
  computed: {
    ...mapGetters(["defaultColorTheme"]),
    modalTitle: function() {
      return "User Preferences";
    },
    isOpen: function() {
      return this.openPrefs;
    },
    colorThemeImg: function() {
      let img = new Image();
      img.src = "../../assets/theme3.png";
      return img;
    },
    colorThemeWidth: function() {
      return this.colorThemeImg.width;
    },
    colorThemeHeight: function() {
      return this.colorThemeImg.height;
    }
  },
  methods: {
    submit() {
      this.$validator
        .validateAll()
        .then(valid => {
          if (!valid) return Promise.reject("Please input values for all default setting fields and color scheme.");

          return Promise.resolve(true);
        })
        .then(() => {
          this.$emit("submitPref", this.prefs);
        })
        .catch(msg => {
          this.$store.commit("displayStatus", { message: msg, level: "error" });
        })
    },
    closeWithoutSave() {
      this.$store.dispatch("getUserPrefs").finally(() => {
        var userPrefs = this.$store.getters.userPrefs;
        this.prefs.pageSize = userPrefs.pageSize;
        this.prefs.patientDateSetting = userPrefs.patientDateSetting;
        this.prefs.examLocation = userPrefs.manualExamUploadLocation;
        this.prefs.defaultColorTheme = userPrefs.defaultColorTheme;
        this.prefs.fullscreens = userPrefs.fullscreen;
        this.prefs.autoPatientExamRefresh = userPrefs.autoPatientExamRefresh;
        this.prefs.defaultHVF = userPrefs.defaultHVF;
        this.prefs.defaultCirrusView = userPrefs.defaultCirrusView;
        this.prefs.defaultHVFview = userPrefs.defaultHVFview;
        this.prefs.multiviewCollapse = userPrefs.multiviewCollapse;
        this.prefs.cirrusScanDisplayRatio = userPrefs.cirrusScanDisplayRatio;
      });
      this.$emit("close");
    },
    closePass() {
      this.isPass = false;
    },
    submitPass() {
      this.$validator.validateAll()
        .then(valid => {
          if (valid) { 
            if (!this.regex.exec(this.newPassword))
              this.errorMsg = "The passwords do not fulfill the minimum password strength requirements. Password must contain 1 uppercase letter, 1 lowercase letter, 1 number, and 1 symbol. They must also be at least 8 characters in length.";
            else if (this.newPassword == this.confirmNewPass) {
              return Promise.resolve(true);
            } 
            else 
              this.errorMsg = "The passwords do not match.";
          }
          else 
            this.errorMsg = "The passwords do not fulfill the minimum password strength requirements. Password must contain 1 uppercase letter, 1 lowercase letter, 1 number, and 1 symbol. They must also be at least 8 characters in length.";
          return Promise.reject();
        })
        .then(() => {
            this.$store
              .dispatch("loginChangePass", {
                oldPassword: this.oldPassword,
                newPassword: this.newPassword
              })
              .then(result => {
                if (result != "SUCCESS") {
                  this.errorMsg = result;
                } else {
                  this.errorMsg = null;
                }
              }).catch(() => {
                this.errorMsg = "An unexpected error occurred, please try again later.";
              }).finally(() => {
                this.isPass = false;
              });
        });
    },
    selectedDarkGreenTheme() {
      this.prefs.defaultColorTheme = "green";
    },
    selectedDarkBlueTheme() {
      this.prefs.defaultColorTheme = "dark-blue";
    },
    selectedDarkGrayTheme() {
      this.prefs.defaultColorTheme = "gray";
    },
    selectedLightTheme() {
      this.prefs.defaultColorTheme = "white";
    },
    changePass() {
      this.errorMsg = null;
      this.isPass = true;
    }
  }
};
</script>